var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.571,
    height: 12,
    viewBox: "0 0 8.571 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__2",
    "data-name": "__TEMP__SVG__",
    d: "M11.57,13.142a.429.429,0,0,1-.285-.107L7.714,9.858,4.141,13.035a.429.429,0,0,1-.713-.321V2.857A1.716,1.716,0,0,1,5.142,1.143h5.142A1.716,1.716,0,0,1,12,2.857v9.856A.429.429,0,0,1,11.57,13.142Z",
    transform: "translate(-3.428 -1.143)",
    fill: "#b7b7b7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.1c691f300c6784b57c9d3ebfd3cebb3c.svg";
export { ForwardRef as ReactComponent };